import axios from "axios";
import { SETTINGS } from "../properties/Settings";

const url = `${SETTINGS.API_URL}consignment-imports`;
export const ConsignmentImportRepository = {
  limits: () => axios.get(`${url}/limits`),
  organizations: (searchString) => axios.get(`${SETTINGS.API_URL}organizations/getBySearchString`, { params: { searchString } }),
  list: (page = 0) => axios.get(url, { params: { page, size: 15 } }),
  upload: (files, organizationId, onUploadProgress) => {
    const data = new FormData();
    files.forEach((file) => data.append("files", file));
    if (organizationId) data.append("organizationId", organizationId);
    return axios.post(url, data, { onUploadProgress });
  },
  retry: (id) => axios.post(`${url}/${id}/retry`),
  originalFile: (id, position) => axios.get(`${url}/${id}/files/${position}`, { responseType: "blob" }),
  extraction: (id) => axios.get(`${url}/${id}/extraction`),
};
